import { Flex } from 'antd';
import classNames from 'classnames';

import styles from './summary-card.module.css';

interface SummaryCardProps {
  title: string;
  counter: number | undefined;
  icon: JSX.Element;
  isMobile: boolean;
}

const DAY_SYMBOL = 'd';

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  counter,
  icon,
  isMobile,
}) => {
  const counterValue = counter || 0;

  return (
    <Flex className={classNames(styles.wrapper, isMobile ? 'mobile' : null)}>
      <Flex vertical>
        <span className={styles.title}>{title}</span>
        <span className={styles.counter}>{`${counterValue}${DAY_SYMBOL}`}</span>
      </Flex>
      {icon}
    </Flex>
  );
};

export default SummaryCard;
